import React from 'react';
import { useData } from '../backend/firebase';

const GoFundMeEmbed = ({ type = 'medium' }) => {
    const { donationsContent } = useData();
    
    // 1. Get Data from Admin Panel (with fallbacks)
    const raised = Number(donationsContent?.raised || 700); 
    const goal = Number(donationsContent?.goal || 2000);
    const percentage = Math.min(100, Math.max(0, (raised / goal) * 100));

    // 2. Define Separate Links
    const mainUrl = "https://www.gofundme.com/f/bridge-brawl-support-the-prize-pool";
    const donateUrl = "https://www.gofundme.com/f/bridge-brawl-support-the-prize-pool/donate?source=btn_donate";
    
    // Styling
    const isLarge = type === 'large';
    const cardWidth = isLarge ? '600px' : '350px';
    const cardPadding = isLarge ? '30px' : '20px';

    return (
        <div style={{width: '100%', display: 'flex', justifyContent: 'center', margin: '25px 0'}}>
            
            {/* CARD: Clicks go to MAIN PAGE */}
            <div 
                onClick={() => window.open(mainUrl, '_blank')}
                style={{
                    width: '100%',
                    maxWidth: cardWidth,
                    background: 'linear-gradient(145deg, rgba(40, 35, 70, 0.9) 0%, rgba(20, 18, 35, 0.95) 100%)',
                    borderRadius: 20,
                    padding: cardPadding,
                    border: '1px solid rgba(108, 93, 211, 0.3)',
                    transform: 'translateZ(0)',        // Force GPU Layer
                    WebkitTransform: 'translateZ(0)',  // Safari/iOS Fix
                    willChange: 'transform',           // Hint to browser
                    boxShadow: '0 10px 30px rgba(0,0,0,0.4)',
                    cursor: 'pointer',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    position: 'relative',
                    overflow: 'hidden'
                }}
                onMouseEnter={e => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 15px 40px rgba(108, 93, 211, 0.2)';
                }}
                onMouseLeave={e => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.4)';
                }}
            >
                {/* Header */}
                <div style={{textAlign: 'center', marginBottom: 15}}>
                    <h3 style={{margin: 0, fontSize: isLarge ? 20 : 16, color: '#fff', fontWeight: 'bold'}}>
                        Bridge Brawl Prize Pool
                    </h3>
                </div>

                {/* Amount Display */}
                <div style={{textAlign: 'center', marginBottom: 15}}>
                    <span style={{
                        fontSize: isLarge ? 42 : 32, 
                        fontWeight: '800', 
                        color: '#fff',
                        textShadow: '0 0 20px rgba(108, 93, 211, 0.5)'
                    }}>
                        ${raised.toLocaleString()}
                    </span>
                    <span style={{fontSize: 14, color: '#8F9EB5', marginLeft: 8}}>
                        raised of ${goal.toLocaleString()} goal
                    </span>
                </div>

                {/* Progress Bar */}
                <div style={{
                    width: '100%', 
                    height: 10, 
                    background: 'rgba(255,255,255,0.1)', 
                    borderRadius: 10, 
                    overflow: 'hidden',
                    marginBottom: 20
                }}>
                    <div style={{
                        width: `${percentage}%`,
                        height: '100%',
                        background: 'linear-gradient(90deg, #6C5DD3 0%, #00d4ff 100%)',
                        borderRadius: 10,
                        transition: 'width 1s ease-out'
                    }}></div>
                </div>

                {/* BUTTON: Clicks go to DONATE LINK */}
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <button 
                        onClick={(e) => {
                            e.stopPropagation(); // Stop click from bubbling to card
                            window.open(donateUrl, '_blank');
                        }}
                        style={{
                            background: '#26A65B', // GoFundMe Green
                            color: 'white',
                            border: 'none',
                            padding: isLarge ? '12px 40px' : '10px 30px',
                            borderRadius: 50,
                            fontWeight: 'bold',
                            fontSize: 14,
                            cursor: 'pointer',
                            boxShadow: '0 4px 15px rgba(38, 166, 91, 0.4)',
                            transition: 'background 0.2s'
                        }}
                        onMouseEnter={e => e.target.style.background = '#219150'}
                        onMouseLeave={e => e.target.style.background = '#26A65B'}
                    >
                        Donate Now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GoFundMeEmbed;